import React from "react";

const HELP_DOC_PATH = `${process.env.PUBLIC_URL}/help/sms-and-email-placeholders.html`;

/**
 * Opens the SMS/Email placeholder guide (hosted from public/help) in a new tab.
 * Pass `anchor` to deep-link to a section of the guide, e.g. "auto-sms".
 */
const PlaceholderHelpLink = ({ anchor }) => {
  const href = anchor ? `${HELP_DOC_PATH}#${anchor}` : HELP_DOC_PATH;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="button is-small is-info is-light is-radiusless"
      title="Open the placeholder guide in a new tab"
    >
      <span className="icon is-small">
        <i className="fas fa-question-circle" />
      </span>
      <span>Placeholder Guide</span>
    </a>
  );
};

export default PlaceholderHelpLink;
